var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 242,
    height: 242,
    viewBox: "0 0 242 242",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2551_2343)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241.95 120.97C241.95 54.16 187.79 0 120.97 0C54.15 0 0 54.16 0 120.97C0 127.14 0.47 133.2 1.36 139.13H240.59C241.48 133.21 241.95 127.15 241.95 120.97ZM105.82 123.98C77.8 123.98 55.08 101.26 55.08 73.24C55.08 45.22 77.8 22.5 105.82 22.5C118.45 22.5 129.99 27.12 138.87 34.76C131.99 30.53 123.9 28.08 115.23 28.08C90.29 28.08 70.07 48.3 70.07 73.24C70.07 98.18 90.29 118.4 115.23 118.4C123.9 118.4 131.99 115.95 138.87 111.72C129.99 119.35 118.45 123.98 105.82 123.98ZM191.63 81.63L170.79 80.91L184.35 96.75L165.89 87.06L171.23 107.22L158.8 90.48L154.87 110.96L150.94 90.48L138.51 107.22L143.85 87.06L125.39 96.75L138.95 80.91L118.11 81.63L137.2 73.24L118.11 64.85L138.95 65.57L125.39 49.73L143.85 59.42L138.51 39.26L150.94 56L154.87 35.52L158.8 56L171.23 39.26L165.89 59.42L184.35 49.73L170.79 65.57L191.63 64.85L172.54 73.24L191.63 81.63Z",
    fill: "#22205F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.79 65.58L184.35 49.74L165.88 59.43L171.22 39.27L158.8 56.02L154.86 35.54L150.93 56.02L138.5 39.27L143.84 59.43L125.38 49.74L138.94 65.58L118.1 64.86L137.19 73.25L118.1 81.64L138.94 80.92L125.38 96.76L143.84 87.07L138.5 107.22L150.93 90.48L154.86 110.96L158.8 90.48L171.22 107.22L165.88 87.07L184.35 96.76L170.79 80.92L191.63 81.64L172.54 73.25L191.63 64.86L170.79 65.58Z",
    fill: "#FFCD05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0701 73.2498C70.0701 48.3098 90.2901 28.0898 115.23 28.0898C123.9 28.0898 131.99 30.5398 138.87 34.7698C129.99 27.1398 118.45 22.5098 105.82 22.5098C77.8001 22.5098 55.0801 45.2298 55.0801 73.2498C55.0801 101.27 77.8001 123.99 105.82 123.99C118.45 123.99 129.99 119.37 138.87 111.73C131.99 115.96 123.9 118.41 115.23 118.41C90.2901 118.41 70.0701 98.1898 70.0701 73.2498Z",
    fill: "#FFCD05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.59 139.13H1.36035C2.25035 145.07 3.58035 150.87 5.31035 156.49H236.65C238.38 150.87 239.7 145.07 240.6 139.13H240.59Z",
    fill: "#D32627"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.65 172.07H11.2998C14.1398 178.15 17.4598 183.96 21.2298 189.43H220.72C224.49 183.95 227.82 178.15 230.65 172.07Z",
    fill: "#D32627"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.96 205.01C40.28 211.55 47.33 217.38 54.99 222.37H186.96C194.61 217.38 201.66 211.55 207.99 205.01H33.96Z",
    fill: "#D32627"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.97 241.95C136.9 241.95 152.11 238.86 166.04 233.27H75.9004C89.8304 238.87 105.04 241.95 120.97 241.95Z",
    fill: "#D32627"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2551_2343"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 241.95,
    height: 241.95,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyFlag);
export default __webpack_public_path__ + "static/media/myFlag.e9fe80c6c1e745dcf893901eab3c2f12.svg";
export { ForwardRef as ReactComponent };